import React, {
  ForwardedRef,
  forwardRef,
  ReactNode,
  useRef,
} from 'react';
import noop from 'lodash/noop';
import Button from 'pages/Dashboard/components/Button';
import FileInput from 'pages/Dashboard/components/FilePicker/FileInput';

export type FileLocalUrl = {
  dataUrl?: string;
  file?: File;
  name?: string;
  readonly?: boolean;
  id?: string;
};

export type ButtonProps = {
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'primary' | 'secondary' | 'inherit';
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
};

type Props = ButtonProps & {
  allowedFileTypes?: string;
  onFileSelect?: (file: File) => void;
  onFileUpload: (data: FileLocalUrl[], file?: File) => void;
  children?: ReactNode;
  multiple?: boolean;
};

const FilePicker = forwardRef(({
  variant = 'text',
  color = 'primary',
  className,
  onFileSelect = noop,
  onFileUpload,
  allowedFileTypes,
  children,
  onClick: _onClick,
  disabled = false,
  multiple = false,
}: Props, ref: ForwardedRef<HTMLInputElement>) => {
  const filePickerRef = useRef<HTMLInputElement | null>(null);

  const onClick = _onClick ?? (() => {
    filePickerRef?.current?.click();
  });

  return (
    <>
      <Button
        className={className}
        variant={variant}
        color={color}
        type="button"
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </Button>
      <FileInput
        ref={ref ?? filePickerRef}
        onFileUpload={onFileUpload}
        allowedFileTypes={allowedFileTypes}
        multiple={multiple}
      />
    </>
  );
});

export default FilePicker;
